import yup from "@/yup";

export function useSchema() {
  return yup.object({
    password: yup
      .string()
      .min(6)
      .transform((value) => (!value ? undefined : value)),
    isBalanceUnlimited: yup.boolean(),
    isBlocked: yup.boolean(),
    canHaveChildren: yup.boolean(),
    isConvActive: yup.boolean(),
  });
}

export type ISchema = yup.InferType<ReturnType<typeof useSchema>>;
